<div class="mobile-footer">
  <noda-link-list [items]="footerData()" />
</div>
